import * as AppConstants from "AppConstants";
import { authHeader } from "app/services/auth.header.service";

/**
 * Knowledge Service - Knowledge Management API calls
 */

// Document Management
export const fetchAllDocuments = async () => {
    const response = await fetch(AppConstants.GET_ALL_DOCUMENTS_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const fetchDocumentById = async (documentId) => {
    const url = AppConstants.GET_DOCUMENT_BY_ID_ENDPOINT.replace(AppConstants.DOCUMENT_ID_PLACEHOLDER, documentId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createDocument = async (documentData) => {
    const response = await fetch(AppConstants.CREATE_DOCUMENT_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(documentData),
    });
    return response.json();
};

export const uploadDocument = async (formData) => {
    const headers = authHeader();
    // Remove Content-Type for multipart form data - browser will set it automatically
    delete headers["Content-Type"];
    
    const response = await fetch(AppConstants.CREATE_DOCUMENT_ENDPOINT, {
        method: "POST",
        headers: headers,
        body: formData,
    });
    return response.json();
};

export const updateDocument = async (documentId, documentData) => {
    const url = AppConstants.UPDATE_DOCUMENT_ENDPOINT.replace(AppConstants.DOCUMENT_ID_PLACEHOLDER, documentId);
    const response = await fetch(url, {
        method: "PUT",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(documentData),
    });
    return response.json();
};

export const deleteDocument = async (documentId) => {
    const url = AppConstants.DELETE_DOCUMENT_ENDPOINT.replace(AppConstants.DOCUMENT_ID_PLACEHOLDER, documentId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: authHeader(),
    });
    return response.ok;
};

export const downloadDocument = async (documentId) => {
    const url = AppConstants.DOWNLOAD_DOCUMENT_ENDPOINT.replace(AppConstants.DOCUMENT_ID_PLACEHOLDER, documentId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.blob();
};

// Tag Management
export const fetchAllTags = async () => {
    const response = await fetch(AppConstants.GET_ALL_TAGS_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createTag = async (tagData) => {
    const response = await fetch(AppConstants.CREATE_TAG_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(tagData),
    });
    return response.json();
};

export const deleteTag = async (tagId) => {
    const url = AppConstants.DELETE_TAG_ENDPOINT.replace(AppConstants.TAG_ID_PLACEHOLDER, tagId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: authHeader(),
    });
    return response.ok;
};

